module.exports = [
	{
		"form": "system/img/forms/492c1.png",
		"colors": {
			"back": "#000000",
			"color": "#80C848",
			"border": "#80C848"
		}
	},
	{
		"form": "system/img/forms/492a.png",
		"colors": {
			"back": "#800020",
			"color": "#F8F8FF",
			"border": "#1E90FF"
		}
	},
	{
		"form": "system/img/forms/488a.png",
		"colors": {
			"back": "#000000",
			"color": "#FFF8DC",
			"border": "#008030"
		}
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reducers/teamColors.json
 ** module id = 704
 ** module chunks = 0
 **/